import { ROUTES } from 'configs/routes';
import { NotificationEntity, NotificationType } from 'entities/Notification';

type NotificationLinkConfig = {
  label: string;
  to: (notification: NotificationEntity) => string;
  state?: (notification: NotificationEntity) => unknown;
};

const getLeadExpLink = (notification: NotificationEntity): string => {
  if (notification.type !== 'LEAD_EXP') {
    return ROUTES.lk.leads.create();
  }

  return ROUTES.lk.leads.detail.create(notification.extra.leadId);
};

const getPromotionLink = (notification: NotificationEntity): string => {
  if (notification.type !== 'PROMOTION') {
    return ROUTES.lk.promotions.create();
  }

  return ROUTES.lk.promotions.detail.create(notification.extra.slug);
};

const getNewsLink = (notification: NotificationEntity): string => {
  if (notification.type !== 'NEWS') {
    return ROUTES.lk.publications.create();
  }

  return ROUTES.lk.publications.detail.create(notification.extra.slug);
};

export const notificationLinkConfigMap: Partial<Record<NotificationType, NotificationLinkConfig>> = {
  LEAD_EXP: {
    label: 'К заявке',
    to: getLeadExpLink,
  },
  ACCREDITATION_STAGE_CHANGED: {
    label: 'К профилю компании',
    to: () => ROUTES.lk.profile.create(),
    state: (notification) => ({
      accreditationRefreshKey: `notification-${notification.id}`,
    }),
  },
  PROMOTION: {
    label: 'К акции',
    to: getPromotionLink,
  },
  NEWS: {
    label: 'К новости',
    to: getNewsLink,
  },
};
